import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=2217b37c&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
import style0 from "./Edit.vue?vue&type=style&index=0&id=2217b37c&prod&lang=scss"
import style1 from "./Edit.vue?vue&type=style&index=1&id=2217b37c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2217b37c",
  null
  
)

export default component.exports